module.exports = __webpack_public_path__ + "Logo-Neumomed-para-PlayStore.png?123bf15083fc7faaebbafd1d2aa82f38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo-Neumomed-para-PlayStore.png
// module id = 746
// module chunks = 0